// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3496C","inputWrap":"CustomTip_inputWrap__1VQiW"};